import React from 'react';

import { ReactComponent as LogoAmex } from 'src/assets/icons/logo-amex.svg';
import { ReactComponent as LogoMastercard } from 'src/assets/icons/logo-mastercard.svg';
import { ReactComponent as LogoStripe } from 'src/assets/icons/logo-stripe.svg';
import { ReactComponent as LogoVisa } from 'src/assets/icons/logo-visa.svg';

import './payment-logos.scss';

const PaymentLogos = () => {
  return (
    <div className="payment-logos">
      <ul className="payment-logos__cards">
        <li className="payment-logos__card">
          <LogoVisa className="payment-logos__card-logo" />
        </li>
        <li className="payment-logos__card">
          <LogoAmex className="payment-logos__card-logo" />
        </li>
        <li className="payment-logos__card">
          <LogoMastercard className="payment-logos__card-logo" />
        </li>
      </ul>
      <LogoStripe className="payment-logos__card-logo" />
    </div>
  );
};

export default PaymentLogos;
